export let addToCart = "addToCart";
export let clearCart = "clearCart";
export let increaseQuantity = "increaseQuantity";
export let decreaseQuantity = "decreaseQuantity";
export let removeItem = "removeItem";
